import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import moment from 'moment'
import {
  Div, Icon, Button, H4, SmallText, P, Input, Loading,
} from 'konsys-ui'
import numeral from 'numeral'
import {
  message, Row, Col, Select, DatePicker, Popover, AutoComplete, Modal,
} from 'antd'
import { useMutation, useQuery } from '@apollo/react-hooks'
import UIfx from 'uifx'
import Quagga from 'quagga'
import { Trash, Trash2 } from 'lucide-react'
import { CREATE_GOOD_RECEIVED } from '../../../constants/graph/mutation'
import {
  GOOD_RECEIVED_LIST, SUPPLIERS, INVENTORIESPO, LOWINVENTORIESPO, PURCHASE_ORDER_LIST_FOR_GR,
} from '../../../constants/graph/query'
import { detailMode } from '../constants'
import { verifyFields, checkFloat, checkInt } from '../../../utils/util-services'
import {
  TextareaWithLabel, FullPageContainer, Divider, InputWithLabel, SelectWithLabel, GroupRowSelect, Uploader,
} from '../../../components/common'
import history from '../../../history'
import { theme } from '../../../styles/_variables'
import Scanner from './quaga'
import bellAudio from './beep-08b.mp3'


const QrScan = async (props) => {
  const {
    data: {
      cameraOn, setCameraOn, onChange, currentItem, setCurrentItem, data: propsData,
    },
  } = props
  const onDetected = (r) => {
    const bell = new UIfx(
      bellAudio,
      {
        volume: 0.8,
        throttleMs: 100,
      },
    )
    bell.play()
    if (currentItem === propsData.inventoryOptionId) {
      props.data.onChange(propsData.quantity + 1, 'quantity', 'number')
    }
  }

  if (cameraOn === false || cameraOn === undefined || _.isEmpty(propsData)) return <Loading center='true' />

  return Modal.info({
    width: 750,
    icon: <Icon color={theme.color.warning} icon='fas fa-exclamation-triangle' style={{ float: 'left', marginRight: '8px', fontSize: theme.fonts.size.subTitle }} />,
    title: 'สแกน บาร์โค้ด',
    content: (cameraOn && <Scanner key={propsData.inventoryOptionId} onDetected={onDetected} props={props}/>) || <Div>กรุณารอสักครู่</Div>,
    okText: 'ปิด',
    destroyOnClose: true,
    onOk() {
      Quagga.offDetected()
      Quagga.stop()
    },
    onCancel() {
      Quagga.offDetected()
      Quagga.stop()
    },
  })
}
const InputRow = (props) => {
  const {
    data, onChange, onDelete, currentItem, setCurrentItem,
  } = props
  const totalPrice = _.isEmpty(props.data) ? 0 : (props.data.quantity * props.data.buyPrice) - (props.data.quantity * props.data.discount)
  const [cameraOn, setCameraOn] = useState(undefined)
  return (
    <Div display='flex' alignItems='center' justifyContent='space-between' {...props}>
      <Trash2 className='cursor-pointer text-blue-500' onClick={() => props.onDelete && props.onDelete()} />
      <Div width='100%' display='flex' alignItems='center'>
        <P style={{ width: '88%' }} margin='0 40px 0 0'>{props.data.sku} {props.data.productName} {props.data.packName} {props.data.brand}</P>
        <Button
          small
          inverse
          key={props.data.inventoryOptionId}
          text="แสกนbarcode"
          onClick={(async () => {
            QrScan({
              data: {
                ...props,
                currentItem: props.data.inventoryOptionId,
                cameraOn: true,
              },
            })
          })}
        ></Button>
        <Input
          defaultValue={_.isNaN(props.data.quantity) ? '0' : `${props.data.quantity}`}
          value={props.data.quantity}
          onChange={(e) => {
            props.onChange(e.target.value < 0 ? 0 : e.target.value, 'quantity', 'number')
          }}
          onKeyDown={(e) => {
            if (!checkFloat(e)) {
              e.preventDefault()
            }
          }}
          width='12%'
          margin='0 0 0 10px'
          state='default'
          rule={{ type: 'float' }}
        />
      </Div>
    </Div>
  )
}

const Render = ({
  isCreateMode, infoData, mutationLoading, doAction, props, currentItem, setCurrentItem,
}) => {
  // const {
  //   loading: supplierLoading, data: supplierData, error: supplierError, refetch: supplierRefetch,
  // } = useQuery(SUPPLIERS)
  const {
    loading: inventoryLoading, data: inventoryData, error: inventoryError, refetch: inventoryRefetch,
  } = useQuery(INVENTORIESPO)
  const {
    loading: purchaseOrderLoading, data: purchaseOrderData, error: purchaseOrderError, refetch: purchaseOrderRefetch,
  } = useQuery(PURCHASE_ORDER_LIST_FOR_GR, { variables: { status: 'ALL', Inventory: { productGroup: 'PARTS' } } })
  const [mutationVariables, setMutationVariables] = useState(isCreateMode ? {} : {
    warehouseCode: infoData.findWarehouse.data.warehouseCode,
    warehouseName: infoData.findWarehouse.data.warehouseName,
  })
  const [selectedItemEmptyList, setSelectedItemEmptyList] = useState([])
  const [selectedItemPRList, setSelectedItemPRList] = useState([])
  const [shippingCost, setShippingCost] = useState(0)
  const [searchPO, setSearchPO] = useState()
  const [searchInventory, setSearchInventory] = useState()
  const [fileList, setFileList] = useState([])
  const [disabledButton, setDisabledButton] = useState(false)
  const onInputRowChange = (type, value, key, valueType, index) => {
    const newArray = type === 'po' ? [...selectedItemPRList] : [...selectedItemEmptyList]
    newArray[index][key] = valueType === 'date' ? moment(value, 'DDMMYY', 'Asia/Bangkok') : valueType === 'number' ? value ? parseFloat(value, 10) : 0 : value
    if (type === 'po') {
      setSelectedItemPRList(newArray)
    } else {
      setSelectedItemEmptyList(newArray)
    }
  }

  const onInputRowDelete = (type, index) => {
    const newArray = type === 'po' ? [...selectedItemPRList] : [...selectedItemEmptyList]
    _.remove(newArray, (v, i) => i === index)
    if (type === 'po') {
      setSelectedItemPRList(newArray)
    } else {
      setSelectedItemEmptyList(newArray)
    }
  }

  const rowRenderData = (v, type, prDetail) => {
    const key = 'inventoryOption'
    const inventoryOptions = type === 'po' ? v.OrderItems.map(u => u.InventoryOption) : v.inventoryOptions
    const variantList = !_.isEmpty(inventoryOptions) && _.isArray(inventoryOptions) && inventoryOptions.map((o, i) => (
      {
        inventoryId: type === 'po' ? o.inventory.id : v.id,
        orderItemId: type === 'po' ? v.OrderItems[i].id : null,
        inventoryOptionId: type === 'po' ? o.id : o.id,
        sku: type === 'po' ? o.inventory.sku : v.sku,
        // quantity: type === 'po' ? v.OrderItems[i].quantity - v.OrderItems[i].receivedQuantity : 1,
        quantity: 0,
        buyPrice: type === 'po' ? o.buyPrice || 0 : v.inventoryOptions.buyprice || 0,
        isVat: type === 'po' ? o.isVat : v.inventoryOptions.isVat,
        vat: type === 'po' ? o.vat : v.inventoryOptions.vat,
        id: type === 'po' ? v.id : null,
        poNumber: type === 'po' ? prDetail.refId : null,
        prItemId: type === 'po' ? v.OrderItems[i].id : null,
        discount: 0,
        productName: type === 'po' ? o.inventory.productName : v.productName,
        brand: type === 'po' ? o.inventory.brand : v.brand,
        name: type === 'po' ? o.inventory.productName : o,
      }
    ))

    return {
      header: type !== 'po' ? [] : [
        {
          // sku: type === 'po' ? v.InventoryOption.inventory.sku : v.sku,
          value: type === 'po' ? `${prDetail.refId}` : v.id,
          checked: type === 'po' ? _.isEmpty(_.differenceBy(variantList, selectedItemPRList, 'id')) : _.isEmpty(_.differenceBy(variantList, selectedItemEmptyList, 'sku')),
          onChange: (e) => {
            if (e.target.checked) {
              // if (type === 'po' ? !_.isEmpty(v[0][key]) : v[key].length > 0) {
              if (type === 'po' ? v.OrderItems.length > 0 : v[key].length > 0) {
                const newList = type === 'po' ? (variantList) : _.concat(...selectedItemEmptyList, variantList)
                if (type === 'po') {
                  setSelectedItemPRList(newList)
                } else {
                  setSelectedItemEmptyList(newList)
                }
              }
            } else {
              const newList = type === 'po' ? [...selectedItemPRList] : [...selectedItemEmptyList]
              inventoryOptions.forEach((t, i) => {
                _.remove(newList, (o) => {
                  if (type === 'po') {
                    // return o.inventoryId === v.id && o.id === v[i].data.id
                    return o.inventoryId === t.inventory.id && o.id === v.id
                  }
                  return o.inventoryId === v.id
                })
              })
              if (type === 'po') {
                setSelectedItemPRList(newList)
              } else {
                setSelectedItemEmptyList(newList)
              }
            }
          },
          data: [
            {
              title: { text: type === 'po' ? 'เลขใบ PO' : 'รหัสสินค้า' },
              content: { text: type === 'po' && !_.isUndefined(prDetail.refId) ? prDetail.refId : v.sku },
            },
          ],
        },
      ], // end-header
      items: !_.isEmpty(inventoryOptions) ? inventoryOptions.map((d, i) => {
        if (!_.isEmpty(d)) {
          const {
            totalStock, soldStock, tobeStocked, preordered,
          } = d
          const minimumStock = d.minimumStock ? d.minimumStock : 0
          // const amountStock = _.find(d.stockLocation, o => o.warehouse.warehouseCode === '00001').quantity
          return (
            {
              id: type === 'po' ? `${v.id} ${d.inventory.sku}` : v.sku,
              value: type === 'po' ? `${v.id}  ${d.inventory.sku}` : v.sku,
              name: type === 'po' ? `${v.id}  ${d.inventory.sku}` : v.sku,
              checked: !_.isEmpty(_.find(type === 'po' ? selectedItemPRList : selectedItemEmptyList, (o) => {
                if (type === 'po') {
                  return o.sku === d.inventory.sku && o.id === v.id
                }
                return o.sku === v.sku
              })),
              onChange: (e) => {
                if (e.target.checked) {
                  if (_.isEmpty(_.find(selectedItemEmptyList, (o) => {
                    if (type === 'po') {
                      return o.sku === d.inventory.sku && o.id === v.id
                    }
                    return o.sku === v.sku
                  }))) {
                    const newList = type === 'po' ? [...selectedItemPRList] : [...selectedItemEmptyList]
                    if (type === 'po') {
                      newList.push(_.find(variantList, dd => dd.inventoryId === d.inventory.id))
                      setSelectedItemPRList(newList)
                    } else {
                      newList.push(_.find(variantList, dd => dd.inventoryId === v.id))
                      setSelectedItemEmptyList(newList)
                    }
                  }
                } else {
                  const newList = type === 'po' ? [...selectedItemPRList] : [...selectedItemEmptyList]
                  _.remove(newList, (o) => {
                    if (type === 'po') {
                      return o.inventoryId === d.inventory.id && o.id === v.id
                    }
                    return o.inventoryId === v.id
                  })
                  if (type === 'po') {
                    setSelectedItemPRList(newList)
                  } else {
                    setSelectedItemEmptyList(newList)
                  }
                }
              },
              data: type === 'po' ? [
                {
                  title: { text: 'รหัสสินค้า' },
                  content: {
                    text: type === 'po' ? d.inventory.sku : v.sku,
                    style: { minWidth: '130px' },
                  },
                },
                {
                  title: { text: 'ชื่อ' },
                  content: {
                    text: type === 'po' ? d.inventory.productName : v.productName,
                    style: { width: '100px', wordBreak: 'break-all' },
                  },
                  margin: '0 16px 0 0',
                },
                {
                  title: { text: 'ยี่ห้อ' },
                  content: {
                    text: type === 'po' ? d.inventory ? d.inventory.brand : '-' : v.brand,
                    style: { width: '80px', wordBreak: 'break-all' },
                  },
                  margin: '0 72px 0 0',
                },
                {
                  title: { text: 'จำนวนที่สั่งซื้อ' },
                  content: {
                    text: type === 'po' ? `${v.OrderItems[i].quantity} ${d.inventory.unit || 'ชิ้น'}` : `${minimumStock} ${v.unit || 'ชิ้น'}`,
                    color: theme.color.black,
                  },
                },
                {
                  title: { text: 'จำนวนที่รับแล้ว' },
                  content: {
                    text: type === 'po' ? `${v.OrderItems[i].receivedQuantity} ${d.inventory.unit || 'ชิ้น'}` : `${minimumStock} ${v.unit || 'ชิ้น'}`,
                    color: theme.color.black,
                  },
                },
              ] : [
                {
                  title: { text: 'รหัสสินค้า' },
                  content: {
                    text: type === 'po' ? d.inventory.sku : v.sku,
                    style: { minWidth: '130px' },
                  },
                },
                {
                  title: { text: 'ชื่อ' },
                  content: {
                    text: type === 'po' ? d.inventory.productName : v.productName,
                    style: { width: '100px', wordBreak: 'break-all' },
                  },
                  margin: '0 16px 0 0',
                },
                {
                  title: { text: 'ยี่ห้อ' },
                  content: {
                    text: type === 'po' ? d.inventory ? d.inventory.brand : '-' : v.brand,
                    style: { width: '80px', wordBreak: 'break-all' },
                  },
                  margin: '0 72px 0 0',
                },
              ],
            }
          )
        }
        return null
      }) : [],
    }
  }
  const confirmBeforeCreate = (onOk, onCancel) => {
    Modal.confirm({
      width: 750,
      icon: <Icon color={theme.color.warning} icon='fas fa-exclamation-triangle' style={{ float: 'left', marginRight: '8px', fontSize: theme.fonts.size.subTitle }} />,
      title: 'ยืนยันสร้างใบรับสินค้า หรือไม่ ?',
      content: <Div>
        <P margin='16px 0 0' style={{ fontFamily: theme.fonts.family.normal, fontWeight: theme.fonts.style.medium }} bold color={theme.color.error}>* หากกดสร้างแล้วจะไม่สามารถแก้ไขได้</P>
      </Div>,
      okText: 'ยืนยันการสร้างใบรับสินค้า',
      cancelText: 'กลับไปแก้ไข',
      onOk() {
        onOk()
        return false
      },
      onCancel() {
        onCancel()
      },
    })
  }

  const otherList = (!_.isEmpty(inventoryData)) ? inventoryData.normalInventoryListforPO.data.list.map(v => rowRenderData(v)) : []
  const prList = _.isEmpty(purchaseOrderData) ? [] : _.flattenDeep(purchaseOrderData.PurchaseOrderListForGoodReceive.lists.map(v => (
    rowRenderData(v, 'po', { refId: v.number })
  )))

  return (
    <Div display='flex' flexDirection='column' padding='0 60px'>
      {/* <SmallText bold>Supplier *</SmallText>
      <Row type='flex' gutter={16} align='middle' style={{ margin: '16px -8px 0 -8px' }}>
        <Col span={24}>
          {
            (!supplierLoading || !_.isEmpty(supplierData))
            && <Select
              showSearch
              style={{ width: '100%' }}
              loading={supplierLoading}
              filterOption={(input, option) => option.props.name.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              onSelect={(e) => {
                setMutationVariables({
                  ...mutationVariables,
                  supplierId: e,
                })
              }}
              onSearch={e => supplierRefetch({ name: e })}
              placeholder='พิมพ์เพื่อค้นหา'
            >
              {
                supplierData.supplierList.data.list.map(v => <Select.Option key={v.id} value={v.id} name={v.name}>{v.name}</Select.Option>)
              }
            </Select>
          }
        </Col>
      </Row> */}
      <Row type='flex' gutter={16} align='middle' style={{ margin: '16px -8px 0 0' }}>
      <InputWithLabel
        input={{
          width: '100%',
          // defaultValue: isCreateMode ? undefined : infoData.findWarehouse.data.address.addressNo,
        }}
        onChange={e => setMutationVariables({ ...mutationVariables, supplierRefId: e.target.value })}
        title={{ text: 'เลข reference ของ supplier' }}
      />
      </Row>
      <Divider
        // color='#C2E2BF'
        margin='40px 0'
      />
      <Div margin='0 0 0'>
        <SmallText bold margin='0 0 8px'>สรุปสินค้าจากใบ PO</SmallText>
        {/* { (!purchaseOrderListLoading || !_.isEmpty(purchaseOrderListData))
          && <AutoComplete
          dataSource={purchaseOrderListData.PurchaseOrderList.lists.map(v => v.number)}
          value={searchPO}
          style={{ width: '100%' }}
          disabled={!_.isEmpty(selectedItemPRList)}
          onSelect={(e) => {
            setSearchPO(e)
            purchaseOrderRefetch({ number: e })
          }}
          onSearch={(e) => {
            if (e === '') {
              setSearchPO()
            } else {
              setSearchPO(e)
            }
          }}
          placeholder="ใส่รหัสserial"
          />
        } */}
        { (!purchaseOrderLoading || !_.isEmpty(purchaseOrderData))
          && <AutoComplete
          dataSource={purchaseOrderData.PurchaseOrderListForGoodReceive.lists.map(v => v.number)}
          value={searchPO}
          style={{ width: '100%' }}
          disabled={!_.isEmpty(selectedItemPRList)}
          onSelect={(e) => {
            setSearchPO(e)
            purchaseOrderRefetch({ number: e })
          }}
          onSearch={(e) => {
            if (e === '') {
              setSearchPO()
            } else {
              setSearchPO(e)
              purchaseOrderRefetch({ number: e })
            }
          }}
          placeholder="ใส่หมายเลขPO"
          />
        }
        {
          (!_.isEmpty(prList)) && purchaseOrderData.PurchaseOrderListForGoodReceive.lists.length === 1
          && <Div moreStyle={{ overflow: 'auto', maxHeight: '250px' }}>
            {
              !_.isEmpty(prList)
              && prList.map((v, i) => <GroupRowSelect key={i} list={v} />)
            }
          </Div>

        }
      </Div>
      <Div>
        <SmallText display='block' bold margin='40px 0 8px'>สินค้าอื่นๆในคลังสินค้า</SmallText>
        <Input
          width='100%'
          placeholder='ค้นหาสินค้าจากชื่อสินค้า'
          margin='0 0 8px'
          value={searchInventory}
          onChange={(e) => {
            setSearchInventory(e.target.value)
            inventoryRefetch({ productName: e.target.value })
          }}
        />
        {
          !_.isEmpty(otherList)
          && <Div moreStyle={{ overflow: 'auto', maxHeight: '250px' }}>
            {
              otherList.map((v, i) => <GroupRowSelect key={i} list={v} />)
            }
          </Div>
        }
      </Div>
      <Divider
        // color='#C2E2BF'
        margin='40px 0'
      />
      {
        (!_.isEmpty(selectedItemEmptyList) || !_.isEmpty(selectedItemPRList))
        && <Div margin='0 0 0'>
          <Div margin='0 0 8px 38px' display='flex' alignItems='center'>
            <SmallText style={{ width: '38%' }} bold margin='0 40px 0 0'>สินค้า</SmallText>
            {/* <SmallText style={{ width: '12%' }} bold margin='0 24px 0 0'>จำนวน *</SmallText>
            <SmallText style={{ width: '13%' }} bold margin='0 24px 0 0'>ราคา / ชิ้น *</SmallText>
            <SmallText style={{ width: '13%' }} bold margin='0 24px 0 0'>จำนวน *</SmallText> */}
            <SmallText textAlign='right' style={{ flexGrow: 1 }} bold dmargin='0 24px 0 0'>จำนวน *</SmallText>
          </Div>
        </Div>
      }
      {
        !_.isEmpty(selectedItemPRList)
        && <Div margin='0 0 8px'>
          <SmallText bold margin='0 0 16px'>สรุปสินค้าจากใบ PO</SmallText>
          {
            Object.keys(_.groupBy(selectedItemPRList, 'poNumber')).map(key => <Div key={key}>
              <SmallText bold>{key}</SmallText>
              {
                _.groupBy(selectedItemPRList, 'poNumber')[key].map((n, i) => <InputRow
                  margin={i !== selectedItemPRList.length - 1 ? '0 0 16px' : '0'}
                  key={i}
                  data={n}
                  currentItem={currentItem}
                  setCurrentItem={setCurrentItem}
                  onChange={(value, keyChange, valueType) => {
                    const index = _.findIndex(selectedItemPRList, item => (item.poNumber === key && item.sku === n.sku))
                    if (!_.isNil(index) && !_.isUndefined(keyChange)) {
                      onInputRowChange('po', value, keyChange, valueType, index)
                    }
                  }}
                  onDelete={() => {
                    const index = _.findIndex(selectedItemPRList, item => (item.poNumber === key && item.sku === n.sku))
                    onInputRowDelete('po', index)
                  }}
                />)
              }
            </Div>)
          }
          {
            !_.isEmpty(selectedItemEmptyList)
            && <Divider />
          }
        </Div>
      }
      {
        !_.isEmpty(selectedItemEmptyList)
        && <Div>
          <SmallText bold>สรุปสินค้าอื่นๆที่ได้รับ</SmallText>
          {
            selectedItemEmptyList.map((v, i) => <InputRow
              margin={i !== selectedItemEmptyList.length - 1 ? '0 0 16px' : '0'}
              key={`outPO-${i}`}
              data={v}
              currentItem={currentItem}
              setCurrentItem={setCurrentItem}
              onChange={(value, key, valueType, index) => {
                onInputRowChange('empty', value, key, valueType, i)
              }}
              onDelete={() => {
                onInputRowDelete('empty', i)
              }}
            />)
          }
        </Div>
      }
      {
        (!_.isEmpty(selectedItemEmptyList) || !_.isEmpty(selectedItemPRList))
        && <Divider
          // color='#C2E2BF'
          margin='40px 0'
        />
      }
      <TextareaWithLabel
        margin='8px 0'
        onChange={e => setMutationVariables({ ...mutationVariables, remark: e.target.value })} title={{
          text: 'หมายเหตุ',
        }} textarea={{
          style: { width: '100%' },
          rows: 8,
          margin: '8px 0 0',
          defaultValue: isCreateMode ? undefined : infoData.remark,
        }}
      />
      <Div margin='24px 0 0' width='100%' display='flex' justifyContent='space-between' alignItems='flex-start'>
        <SmallText bold>แนบเอกสาร</SmallText>
        <Uploader
          isMultiple
          sltye={{ border: '1px solid red' }}
          buttonText='คลิกเพื่อเลือกไฟล์'
          inverse={false}
          icon='fal fa-paperclip'
          onChange={(e) => {
            setFileList(e)
          }}
          data={fileList}
        />
      </Div>
      <Button
        loading={mutationLoading}
        text={isCreateMode ? 'สร้างใบรับสินค้า' : 'แก้ไขใบรับสินค้า'}
        disabled={_.isEmpty(selectedItemPRList) || disabledButton}
        icon={isCreateMode ? 'far fa-plus' : 'far fa-edit'}
        style={{ alignItems: 'center' }}
        width='fit-content'
        margin='20px auto'
        onClick={() => {
          setDisabledButton(true)
          confirmBeforeCreate(() => {
            doAction({
              variables: isCreateMode ? {
                ...mutationVariables,
                OrderItem: selectedItemPRList.map(v => _.pick(v, ['quantity', 'orderItemId'])),
                ExtraItem: selectedItemEmptyList.map(v => _.pick(v, ['quantity', 'inventoryOptionId'])),
                purchaseorderId: selectedItemPRList[0].id,
                // orderItemList: _.concat(selectedItemEmptyList.map(v => _.pick(v, ['quantity', 'inventoryOptionId', 'buyPrice', 'salesPrice', 'discount'])), selectedItemPRList.map(v => _.pick(v, ['quantity', 'inventoryOptionId', 'buyPrice', 'salesPrice', 'discount', 'prItemId']))),
                deliveryCost: parseFloat(shippingCost, 10),
                files: fileList,
              } : {
                ...mutationVariables,
                id: parseInt(props.match.params.id, 10),
                warehouseId: 4,
                deliveryCost: parseFloat(shippingCost, 10),
              },
              refetchQueries: [{
                query: GOOD_RECEIVED_LIST,
                variables: {
                  limit: 5, offset: 0, orderField: 'updatedAt', orderBy: 'DESC',
                },
              }],
            }).then((resp) => {
              setDisabledButton(false)
              const KEY = isCreateMode ? 'CreateGoodReceive' : 'UpdateGoodReceive'
              if (resp.data[KEY] && resp.data[KEY].success) {
                message.success(resp.data[KEY].message)
                history.push('/good-received')
              } else message.error(resp.data[KEY].message)
            })
          }, () => {
            setDisabledButton(false)
          })
        }}
      />
    </Div >
  )
}

export default ({ props }) => {
  const isCreateMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const [doAction, { loading: mutationLoading }] = useMutation(CREATE_GOOD_RECEIVED)
  const [currentItem, setCurrentItem] = useState(undefined)
  return (
    <Div>
      <Render
        mutationLoading={mutationLoading}
        doAction={doAction}
        props={props}
        isCreateMode={isCreateMode}
        currentItem={currentItem}
        setCurrentItem={setCurrentItem}
      />
    </Div>
  )
}
